import { Routes } from '@angular/router';
import { ChainAuditComponent } from '@app/features/chain-audit/chain-audit.component';
import { Authority } from '@app/shared/utils/enums';

export const chainAuditRoutes: Routes = [
    {
        path: 'chain-audit',
        children: [
            {
                path: '',
                component: ChainAuditComponent,
                data: {
                    authorities: [Authority.ADMIN]
                }
            }
        ]
    }
]